import { Path } from '@/main/router/routerPath';

import { NAME, CRUMB_LABEL_LIST, CRUMB_LABEL_EDIT } from './constants';
import List from './List.vue';
import Edit from './Edit.vue';

export const router = new Path().addChildren([
	new Path(NAME, { List, SelectList: List }, CRUMB_LABEL_LIST),
	new Path(NAME, { Edit }, CRUMB_LABEL_EDIT),
]);
